import React, { useContext } from "react";

import OrderContext from "~/contexts/OrderContext";
import { useFetcher } from "@remix-run/react";
import { KEYS } from "~/modules/checkout/constants";

import Modal from "~/components/Modal/Modal";
import AuthContext from "~/contexts/AuthContext";

interface SignBackInModalProps {
  visible: boolean;
  wrongAccount: boolean;
}

const SignBackInModal: React.FC<SignBackInModalProps> = ({
  visible,
  wrongAccount,
}) => {
  const fetcher = useFetcher({ key: KEYS.SUBMIT_ORDER_FETCHER });
  const { reset } = useContext(OrderContext);
  const { setIsAuthDialogOpen } = useContext(AuthContext);

  const handleClearCart = () => {
    reset();
  };

  const handleSignBackIn = () => {
    setIsAuthDialogOpen(true);
  };

  fetcher.state !== "idle";
  return (
    <Modal
      title={
        wrongAccount
          ? "Signed in to different account"
          : "You've been signed out"
      }
      visible={visible}
      onClose={() => {}}
      onCancel={handleClearCart}
      onConfirm={handleSignBackIn}
      closeText={wrongAccount ? "Start New Order" : "Clear Cart"}
      okText="Sign Back In"
      bodyText={
        wrongAccount
          ? "Sign back in to the correct account to continue your order, or start a new order"
          : "Sign in to continue your order"
      }
    />
  );
};

export default SignBackInModal;
